import { Typography } from "@mui/material";

export default function StatusLabel({ status }) {

    const getColor = (status) => {
        switch (status) {
            case 1:
                return "success.main";
            case 999:
                return "error.main";
            case 0:
            default:
                return "warning.main";
        }
    };

    const getText = (status) => {
        switch (status) {
            case 1:
                return "APPROVED";
            case 999:
                return "REJECTED";
            case 0:
            default:
                return "WAITING";
        }
    };

    return (
        <Typography
            fontSize={14}
            fontWeight="bold"
            sx={{ color: getColor(status) }}
        >
            {getText(status)}
        </Typography>
    );
}
